import { useState } from "react";
import { ChevronDown, ChevronUp, Loader } from "lucide-react";
import CourseOutcomes from "./Outcomes Section/CourseOutcomes";
import ProgramOutcomes from "./Outcomes Section/ProgramOutcomes";
import ProgramSpecificOutcomes from "./Outcomes Section/ProgramSpecificOutcomes";

const OutcomesView = ({
  outcomes,
  programOutcomes,
  programSpecificOutcomes,
  articulationMatrix,
  isLoading,
  darkMode,
}) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const [expandedSections, setExpandedSections] = useState({
    course: true,
    program: true,
    specific: true,
  });

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const toggleAll = () => {
    setIsExpanded(!isExpanded);
    if (isExpanded) {
      setExpandedSections({
        course: false,
        program: false,
        specific: false,
      });
    } else {
      setExpandedSections({
        course: true,
        program: true,
        specific: true,
      });
    }
  };

  if (isLoading) {
    return (
      <div
        className={`p-4 rounded-lg mb-4 flex items-center justify-center ${
          darkMode
            ? "bg-[#0D1117] border border-[#22232B]"
            : "bg-white border border-[#D1D5DB]"
        }`}
      >
        <Loader size={20} className="animate-spin mr-2" />
        <span className={darkMode ? "text-gray-300" : "text-gray-600"}>
          Loading outcomes data...
        </span>
      </div>
    );
  }

  return (
    <div
      className={`p-4 rounded-lg mb-4 ${
        darkMode
          ? "bg-[#0D1117] border border-[#22232B]"
          : "bg-white border border-[#D1D5DB]"
      }`}
    >
      <div
        className={`rounded-t-lg p-3 -mx-4 -mt-4 mb-3 ${
          darkMode ? "bg-[#1a1f2e]" : "bg-gray-100"
        }`}
      >
        <div className="flex justify-between items-center">
          <h3
            className={`text-base font-semibold ${
              darkMode ? "text-white" : "text-gray-800"
            }`}
          >
            Learning Outcomes
          </h3>
          <button
            onClick={toggleAll}
            className={`flex items-center text-xs ${
              darkMode
                ? "text-gray-300 hover:text-white"
                : "text-gray-600 hover:text-gray-800"
            }`}
          >
            {isExpanded ? (
              <>
                <ChevronUp size={14} className="mr-1" />
                Collapse All
              </>
            ) : (
              <>
                <ChevronDown size={14} className="mr-1" />
                Expand All
              </>
            )}
          </button>
        </div>
      </div>

      <CourseOutcomes
        outcomes={outcomes}
        isExpanded={expandedSections.course}
        onToggle={() => toggleSection("course")}
        darkMode={darkMode}
      />

      <ProgramOutcomes
        outcomes={programOutcomes}
        isExpanded={expandedSections.program}
        onToggle={() => toggleSection("program")}
        darkMode={darkMode}
      />

      <ProgramSpecificOutcomes
        outcomes={programSpecificOutcomes}
        isExpanded={expandedSections.specific}
        onToggle={() => toggleSection("specific")}
        darkMode={darkMode}
      />
    </div>
  );
};

export default OutcomesView;
